import { render, staticRenderFns } from "./WorkAlertContainer.vue?vue&type=template&id=7b2d0682"
import script from "./WorkAlertContainer.vue?vue&type=script&lang=js"
export * from "./WorkAlertContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports